import React from 'react';

export const Search = (props: any) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
    <path
      fillRule="evenodd"
      d="M10.512 0C13.543 0 16 2.456 16 5.487c0 3.03-2.457 5.486-5.488 5.486-1.107 0-2.137-.328-3-.891-.057.14-.143.27-.255.383l-5.18 5.179c-.443.443-1.14.475-1.622.087l-.1-.09c-.475-.476-.47-1.252-.002-1.721l5.18-5.18c.113-.113.243-.199.381-.258-.562-.86-.89-1.89-.89-2.995C5.025 2.457 7.482 0 10.513 0zm0 1.829c-2.02 0-3.658 1.637-3.658 3.658 0 2.02 1.638 3.657 3.658 3.657s3.659-1.637 3.659-3.657-1.638-3.658-3.659-3.658z"
    />
  </svg>
);

export const SearchAlternative = (props: any) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" {...props}>
    <g fill="none" fillRule="evenodd">
      <g fill="currentColor">
        <g>
          <g>
            <path
              d="M18.588 10.569c3.509 0 6.353 2.844 6.353 6.353 0 1.5-.52 2.879-1.39 3.966l4.007 4.005c.276.276.276.723 0 .998-.26.26-.67.275-.948.046l-.05-.046-4.006-4.006c-1.086.87-2.465 1.39-3.966 1.39-3.508 0-6.353-2.845-6.353-6.353 0-3.51 2.845-6.353 6.353-6.353zm0 1.411c-2.729 0-4.94 2.213-4.94 4.942s2.211 4.94 4.94 4.94c2.73 0 4.941-2.211 4.941-4.94 0-2.73-2.212-4.942-4.94-4.942z"
              transform="translate(-361 -270) translate(58 256) translate(291 3.667)"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);
